export default "__VITE_ASSET__BilJasg2__"